import React from "react";
import UserMenu from '../../menus/UserMenu';
import Layout from '../../Layout';

const AppTemplate = ({ children }) => {

    return (
        <Layout userMenu={<UserMenu />}>
            {children}
        </Layout>
    )
}

export default AppTemplate;